// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape, PlateTargetEligibility} from 'pipelines/StepShapeUtils';

export const UPDATE_INVENTORY_PLATES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.UPDATE_INVENTORY_PLATES,
    isDeprecated: false,
    version: 0,
    plateTargetEligibility: PlateTargetEligibility.ANY,
    inputDataShapes: {
      'Input plates': {
        systemName: 'Input plates',
        displayName: 'Input plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      Outputs: {
        systemName: 'Outputs',
        displayName: 'Outputs',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      Errors: {
        systemName: 'Errors',
        displayName: 'Errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Output plates': {
        systemName: 'Output plates',
        displayName: 'Output plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      columnMapping: {
        kind: 'columnMapping',
        required: false,
        fields: {
          wellSchemaFields: {
            kind: 'schemaFields',
            required: true,
            rowSourceField: 'Input plates',
            surfaceFieldRequiredness: false
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
